const TabsBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#ffd400" d="M12 6H2v16h20V6H12z" />
    <path fill="#333" d="M20 4v2h2v16H2V6H0v18h24V4h-4z" />
    <path fill="#ffd400" d="M2 2h4v2H2z" />
    <path fill="#333" d="M2 6h4V4H2V2h4V0H0v6h2z" />
    <path fill="#fff" d="M8 2h4v2H8z" />
    <path fill="#333" d="M6 2v4h6V4H8V2h4V0H6v2z" />
    <path fill="#fff" d="M14 2h4v2h-4z" />
    <path d="M12 2v4h8V0h-8zm2 0h4v2h-4z" fill="#333" />
  </svg>
);

export default TabsBlockIcon;
